import { getOrganizationViewUrl } from '../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'
import { SalesReportVariant } from '../enums/salesReportVariant'
import { SalesByCustomerReport } from '../routes/SalesByCustomerReport'
import { SalesByItemReport } from '../routes/SalesByItemReport'
import { SalesOverviewReport } from '../routes/SalesOverviewReport'

type SalesReportVariantRoute = {
  getVariantRoute: (organizationUrl: string) => string
  component: () => JSX.Element
  variant: SalesReportVariant
}

export const salesReportVariantRoutes: SalesReportVariantRoute[] = [
  {
    component: SalesOverviewReport,
    getVariantRoute: (organizationUrl) =>
      getOrganizationViewUrl(organizationUrl, reactRoute.organization.salesReport.getSalesOverviewRoute()),
    variant: SalesReportVariant.Overview,
  },
  {
    component: SalesByItemReport,
    getVariantRoute: (organizationUrl) =>
      getOrganizationViewUrl(organizationUrl, reactRoute.organization.salesReport.getSalesByItemRoute()),
    variant: SalesReportVariant.ByItem,
  },
  {
    component: SalesByCustomerReport,
    getVariantRoute: (organizationUrl) =>
      getOrganizationViewUrl(organizationUrl, reactRoute.organization.salesReport.getSalesByCustomerRoute()),
    variant: SalesReportVariant.ByCustomer,
  },
]
